import { createSlice } from "@reduxjs/toolkit";
import { getNewsOfNewsHub, getNewsKeyword } from "./thunk";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { INews } from "api/types/newshub/_news";


export interface IState {
  news: ResponseData<INews[]> & PaginationResponse | null,
  isNewsLoading: boolean,
  isNewsSuccess: boolean,

  newsKeyword: ResponseData<INews[]> & PaginationResponse | null,
  isNewsKeywordLoading: boolean,
  isNewsKeywordSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  news: null,
  isNewsLoading: false,
  isNewsSuccess: false,

  newsKeyword: null,
  isNewsKeywordLoading: false,
  isNewsKeywordSuccess: false,

  error: {},
};

const NewsSlice = createSlice({
  name: "news",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    //get Newss
    builder.addCase(getNewsOfNewsHub.pending, (state: IState, action: any) => {
      state.isNewsLoading = true
    });
    builder.addCase(getNewsOfNewsHub.fulfilled, (state: IState, action: any) => {
      state.news = action.payload.data;
      state.isNewsSuccess = true;
      state.isNewsLoading = false;
    });
    builder.addCase(getNewsOfNewsHub.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isNewsSuccess = false;
      state.isNewsLoading = false;
    });

    //get NewsKeyword
    builder.addCase(getNewsKeyword.pending, (state: IState, action: any) => {
      state.isNewsKeywordLoading = true
    });
    builder.addCase(getNewsKeyword.fulfilled, (state: IState, action: any) => {
      state.newsKeyword = action.payload.data;
      state.isNewsSuccess = true;
      state.isNewsKeywordLoading = false;
    });
    builder.addCase(getNewsKeyword.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isNewsSuccess = false;
      state.isNewsKeywordLoading = false;
    });
  },
});

export default NewsSlice.reducer;